import { Comment } from "@iventis/domain-model/model/comment";
import { ResourceType } from "@iventis/domain-model/model/resourceType";
import { Status } from "@iventis/domain-model/model/status";

export function createComment(comment: { id: string; textContent: string; userId: string; resourceId: string; resourceType: ResourceType }): Comment {
    const date = new Date();
    return {
        id: comment.id,
        textContent: comment.textContent,
        createdAt: date,
        lastUpdatedAt: date,
        createdByUserId: comment.userId,
        createdByUserName: null,
        lastUpdatedByUserId: comment.userId,
        lastUpdatedByUserName: null,
        resourceId: comment.resourceId,
        resourceType: comment.resourceType,
        status: Status.Active,
        userId: comment.userId,
        lastViewedAt: null,
    };
}
